<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
          if (this.$route.path !== '/Login') {
            this.$router.push({path:'/Login'})
          }
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  watch: {
    // 切换语言时同步 Vant 内置组件文案（下拉刷新、加载中、没有更多了等）
    '$i18n.locale': {
      handler(val) {
        if (this.$syncVantLocale) {
          this.$syncVantLocale(val);
        }
      }
    }
  },
  created(){
    this.getBaseInfo();
    if (this.$syncVantLocale) {
      this.$syncVantLocale(this.$i18n.locale);
    }
  }
}
</script>

<style lang="less">
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	-webkit-user-drag: none
		/* 禁止用户拖拽 */
	;
}
.noVw{
  .van-button__text{
    font-size: 32px;
  }
}
.flex {
	display: flex;
}

.flex-item {
	align-items: center;
}

.flex-content {
	justify-content: center;
}

.flex-content_end {
	justify-content: end;
}

.flex-between {
	justify-content: space-between;
}

.flex-column {
	flex-direction: column;
}

body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
  /* Vant toast 默认 word-break: break-all，英文会在单词中间断行（如 maximu/m）。
     改为按单词断行；超长无空格串（如钱包地址）由 overflow-wrap 兜底换行 */
  word-break: normal;
  overflow-wrap: break-word;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
